document.addEventListener("scroll", function() {
  const header = document.querySelector(".header-wrapper");
  const brandName = document.querySelector(".header__brand");

  // Check if we've scrolled past a certain point (e.g., 50px)
  if (window.scrollY > 50) {
    header.classList.add("scrolled");
  } else {
    header.classList.remove("scrolled");
  }
});
